import { Injectable } from '@angular/core';
import { PrinterConnectionStatus } from 'app/models/printing.model';
import { Observable } from 'rxjs';
import { BasePingService } from './base-ping.service';

@Injectable({
  providedIn: 'root',
})
export class PrintingSessionService extends BasePingService {
  watch(onStatusChange: (status: PrinterConnectionStatus) => void): Observable<PrinterConnectionStatus> {
    return this.createPingObservable({
      url: '/api/daemon/status',
      defaultValue: this.notAccessible,
      mapResponse: (response: { data: PrinterConnectionStatus; statusCode: number }) => response.data,
      onStatusChange,
    });
  }
}
